<template>
  <div class="template-padding">
    <div class="crewing">
      <!-- section top button -->
      <section>
        <div class="row">
          <div class="col-sm-2 col-md-4">
            <div
              class="btn-group"
              role="group"
              aria-label="Basic example"
            >
              <button
                type="button"
                aria-label="Search"
                aria-describedby="basic-addon2"
                data-toggle="popover"
                data-trigger="hover"
                title="Print"
                data-placement="bottom"
                data-content="Print Processed All Training"
                @click="generateAllTrainingChecklist(id)"
                class="btn btn-outline-primary btn-sm btn-xs font-weight-bold"
              >
                <i class="fa fa-print" /> Print All
              </button>

              <button
                type="button"
                aria-label="Search"
                aria-describedby="basic-addon2"
                data-toggle="popover"
                data-trigger="hover"
                title="Print"
                data-placement="bottom"
                data-content="Print In Processed Training"
                @click="generateOnGoingTrainingChecklist(id)"
                class="btn btn-outline-primary btn-sm btn-xs font-weight-bold"
              >
                <i class="fa fa-print" /> Print In-Process
              </button>

              <button
                type="button"
                class="btn btn-outline-secondary btn-sm btn-xs font-weight-bold"
                @click="goBack"
              >
                <i class="fa fa-backward" />
                Go Back
              </button>
            </div>
          </div>
        </div>
      </section>

      <hr class="hr-color my-1">

      <div
        class="row"
        v-if="crew.detail"
      >
        <div class="col col-sm-4">
          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Crew Code:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.detail.crewcode"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Applicant No:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.detail.applicantno"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Full Name:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.detail | crewFullName"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Birth Date:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.detail.birthdate | moment('DD MMMM YYYY')"
              >
            </div>
          </div>
        </div>

        <div class="col col-sm-4">
          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              EMAIL:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.detail.email"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Rank:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.rank.alias | toUpper"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Last Vessel:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.lastVessel ? crew.lastVessel.vessel : ''"
              >
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Disembark:
            </label>
            <div class="col col-sm-9">
              <input
                type="text"
                readonly
                class="form-control form-control-xs form-display rounded-0"
                :value="crew.lastVessel ? crew.lastVessel.disembark : '' | moment('DD MMMM YYYY')"
              >
            </div>
          </div>
        </div>

        <div class="col col-sm-4">
          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              ETD:
            </label>
            <div class="col col-sm-9">
              <label
                class="form-control form-control-xs form-display rounded-0"
              >
                <!--                                <span v-if="crew.detail.endorsement">{{ crew.detail.endorsement.etd | moment('DD MMM YYYY') }}</span>-->
                <!--                                :value="crew.lastVessel ? crew.lastVessel.disembark : '' | moment('DD MMMM YYYY')"-->
                <span v-if="crew.assignedVessel">{{ crew.assignedVessel.etd | moment('DD MMM YYYY') }}</span>
              </label>
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Assign Vessel:
            </label>
            <div class="col col-sm-9">
              <label
                class="form-control form-control-xs form-display rounded-0"
              >
                <span v-if="crew.assignedVessel">{{ crew.assignedVessel.vessel }}</span>
                <!--                                <span v-if="crew.detail.endorsement">{{ crew.detail.endorsement.vessel.name }}</span>-->
              </label>
            </div>
          </div>

          <div class="form-group form-row mb-1">
            <label class="col col-sm-3 font-weight-bolder col-form-label text-right align-text-bottom pb-0 mb-0">
              Assign Rank:
            </label>
            <div class="col col-sm-9">
              <label
                class="form-control form-control-xs form-display rounded-0"
              >
                <span v-if="crew.assignedVessel">{{ crew.assignedVessel.rank }}</span>
                <!--                                <span v-if="crew.detail.endorsement">{{ crew.detail.endorsement.rank.alias }}</span>-->
              </label>
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-0">

      <!-- section of number of sched training per crew-->

      <section class="mt-2">
        <div class="row">
          <div class="col col-sm-6">
            <div class="row">
              <div class="col col-sm-4">
                <div class="font-weight-bold">
                  Rescheduled Training:
                  <span
                    class="text-danger"
                    style="font-size: 1.5em; !important;"
                  >{{ countTrainingRescheduled }}</span>
                </div>
              </div>

              <div class="col col-sm-4">
                <div class="font-weight-bold">
                  Scheduled Training:
                  <span
                    class="text-primary"
                    style="font-size: 1.5em; !important;"
                  >{{ countTrainingScheduled }}</span>
                </div>
              </div>

              <div class="col col-sm-4">
                <div class="font-weight-bold">
                  Training Completed:
                  <span
                    class="text-primary"
                    style="font-size: 1.5em; !important;"
                  >{{ countTrainingCompleted }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col col-sm-6 pt-1">
            <div class="row">
              <div class="col col-sm-4">
                <i class="fa fa-circle text-success" />
                Complete
              </div>

              <div class="col col-sm-4">
                <b><i class="fa fa-exclamation text-danger" /></b>
                With Allowance
              </div>

              <div class="col col-sm-4">
                <b><i class="fa fa-circle text-isMandatory" /></b>
                Mandatory
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-2">
        <h5 class="m-2 font-weight-bolder">
          Trainings
        </h5>

        <ul
          class="nav nav-tabs"
          id="myTab"
          role="tablist"
        >
          <li class="nav-item">
            <a
                class="nav-link"
                :class="{ active: formParams.trainingProviderId === null }"
                data-toggle="tab"
                href="#overview"
                role="tab"
                @click="getCrewTrainingChecklist()"
            >
              <strong>OVERVIEW</strong>
            </a>
          </li>
          <li
            class="nav-item"
            v-for="(crewTrainingProvider,index) in crewTrainingProviders"
            :key="crewTrainingProvider.id"
          >
            <a
              class="nav-link"
              data-toggle="tab"
              href="#provider"
              role="tab"
              :class="{ active: formParams.trainingProviderId === crewTrainingProvider.id }"
              @click="crewTrainingsPerProvider(crewTrainingProvider.id)"
            >
              <strong>{{ crewTrainingProvider.code }}</strong>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#overview"
              role="tab"
              @click="getAllAcquiredTraining()"
            >
              <strong>ALL ACQUIRED TRAININGS</strong>
            </a>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#allowance-remarks"
              role="tab"
            >
              <strong>ALLOWANCE REMARKS</strong>
            </a>
          </li>
        </ul>

        <div
          class="tab-content"
          id="nav-tabContent"
        >
          <div
            class="tab-pane fade show active"
            id="provider"
            role="tabpanel"
          >
            <table class="table table-hover table-bordered table-padding-1">
              <thead>
                <tr class="table-header">
                  <th class="col-index">
                    #
                  </th>
                  <th class="col-header-wider justify-content-lg-start">
                    Training Name
                  </th>
                  <th>Ranks</th>
                  <!--                                <th class="col-header-month">Vessels</th>-->
                  <th class="col-header-xwider justify-content-lg-start">
                    Venue
                  </th>
                  <th>Status</th>
                  <th>Date From</th>
                  <th>Date To</th>
                  <th>File</th>
                  <th class="col-actions-md">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody
                v-if="crewTrainings"
                class="tbody-content-middle"
              >
                <tr
                  v-for="(crewTraining,index) in crewTrainings"
                  :key="crewTraining.id"
                  :class="{ 'complete':crewTraining.trainingCompleted , 'isMandatory': crewTraining.isMandatory && !crewTraining.trainingCompleted, 'bg-expired': crewTraining.isValid === false }"
                >
                  <td scope="row">
                    {{ index + 1 }}
                  </td>
                  <td
                    v-if="crewTraining.trainingScheduleId"
                    title="View Training History"
                    @click="viewTrainingHistory(crewTraining.trainingCourseId)"
                    style="cursor: pointer"
                  >
                    <b v-if="crewTraining.allowance"><i class="fa fa-exclamation text-danger" /></b>
                    {{ crewTraining.courseName }}
                  </td>

                  <td v-else>
                    {{ crewTraining.courseName }}
                  </td>

                  <td>
                    <span v-if="crewTraining.endorsement">{{ crewTraining.endorsement.rank.alias }}</span>
                    <span v-else>{{ crewTraining.rank }}</span>
                  </td>

                  <td :title="crewTraining.venue">
                    {{ crewTraining.venue }}
                  </td>

                  <td>
                    <div v-if="crewTraining.trainingScheduleId">
                      {{ evaluate(crewTraining) }}
                    </div>
                  </td>

                  <td>
                    <span v-if="crewTraining.dateFrom">{{ crewTraining.dateFrom | moment('D MMM YYYY') }}</span>
                  </td>

                  <td>
                    <span v-if="crewTraining.dateTo">{{ crewTraining.dateTo | moment('D MMM YYYY') }}</span>
                  </td>

                  <td>
                    <span v-if="crewTraining.trainingCompleted">

                      <button
                        type="button"
                        v-if="crewTraining.hasFile"
                        class="btn btn-primary btn-sm p-1 mr-1  action font-weight-bolder btn-scheduling"
                        @click="setCrewTrainingCertificateSrc(crewTraining.crewTrainingId)"
                        data-toggle="modal"
                        data-target="#viewCertificate"
                      >
                        <i class="fas fa-file" />
                        View
                      </button>
                      <button
                        type="button"
                        v-else
                        class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder btn-scheduling"
                        data-toggle="modal"
                        data-target="#uploadCertificate"
                        @click="setCrewCertificate(crewTraining)"
                      >
                        <i class="fas fa-file" />
                        Upload
                      </button>

                      <template v-if="isScheduler">

                        <button
                          type="button"
                          v-if="crewTraining.hasFile && crewTraining.trainingCourseId === 2"
                          class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder"
                          data-toggle="modal"
                          data-target="#update-anti-piracy-number"
                          title="Update Certificate Number"
                        >
                          <i class="fas fa-edit" />
                        </button>
                        <button
                          type="button"
                          v-if="courseWithAutomation.includes(crewTraining.trainingCourseId)"
                          class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder"
                          data-toggle="modal"
                          data-target="#update-crew-certificate"
                          title="Update Crew Certificate"
                          @click="editCrewTraining = crewTraining"
                        >
                          <i class="fas fa-edit" />
                        </button>
                      </template>


                    </span>

                    <template v-if="[114, 115].includes(crewTraining.trainingCourseId) && isScheduler">
                      <button
                        type="button"
                        v-if="crewTraining.hasFile"
                        class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder"
                        data-toggle="modal"
                        data-target="#update-promotion-certificate"
                        @click="promotionTraining = crewTraining"
                        :title="`UPDATE ${crewTraining.courseName} DETAILS`"
                      >
                        <i class="fas fa-edit" />
                      </button>
                      <button
                        type="button"
                        v-else
                        class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder"
                        data-toggle="modal"
                        data-target="#generate-promotion-certificate"
                        @click="promotionTraining = crewTraining"
                        :title="`Generate ${crewTraining.courseName}`"
                      >
                        Generate
                      </button>
                    </template>
<!--                    <template v-if="[135].includes(crewTraining.trainingCourseId) && isScheduler">-->
<!--                      &lt;!&ndash;                        data-toggle="modal"&ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                            data-target="#generate-promotion-certificate"&ndash;&gt;-->
<!--                      <button-->
<!--                        v-if="crewTraining.hasFile && crewTraining.crewTrainingId"-->
<!--                        type="button"-->
<!--                        class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder"-->
<!--                        @click="promotionTraining = crewTraining"-->
<!--                        :title="`Generate ${crewTraining.courseName}`"-->
<!--                        data-toggle="modal"-->
<!--                        data-target="#generate-crew-certificate"-->
<!--                      >-->
<!--                        Generate-->
<!--                      </button>-->
<!--                    </template>-->
<!--                  </td>-->

                  <td>
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm p-1 mr-1  action font-weight-bolder btn-scheduling"
                      @click="$router.push('/trainingSchedule/' + crewTraining.trainingScheduleId)"
                      v-if="crewTraining.trainingScheduleId && !crewTraining.cancelledAt"
                    >
                      <i class="fas fa-eye" />
                      View
                    </button>
                    <!--                                  - {{ crewTraining.trainingScheduleId }} -->
                    <!--                                  - {{ crewTraining.cancelledAt }}-->
                    <!--                                  - {{ crewTraining }}-->

                    <button
                      type="button"
                      class="btn btn-warning btn-sm p-1 mr-1 action font-weight-bolder btn-scheduling"
                      data-toggle="modal"
                      data-target="#crewTrainingReschedule"
                      v-if="(crewTraining.trainingScheduleId && !(evaluate(crewTraining) === 'COMPLETED')) && isScheduler"
                      @click="setCrewTraining(crewTraining)"
                    >
                      <i class="fas fa-clock" />
                      Resched
                    </button>

                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm p-1 action font-weight-bolder btn-scheduling"
                      v-if="(crewTraining.trainingScheduleId && !(evaluate(crewTraining) === 'COMPLETED')) && !crewTraining.cancelledAt && isScheduler"
                      @click="confirmCancelCrewTrainingScheduleOnCrew(crewTraining.crewTrainingScheduleId)"
                    >
                      <i class="fas fa-ban" />
                      Cancel
                    </button>

                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm p-1 action font-weight-bolder btn-scheduling"
                      data-toggle="modal"
                      data-target="#createCrewSchedModal"
                      @click="setCrewTraining(crewTraining)"
                      v-if="(!crewTraining.trainingScheduleId || (evaluate(crewTraining) === 'COMPLETED') || crewTraining.cancelledAt) && isScheduler"
                    >
                      <i class="fas fa-clock" />
                      Sched
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="tab-pane fade show"
            id="overview"
            role="tabpanel"
          >
            <table class="table table-hover table-bordered table-padding-1">
              <thead>
                <tr class="table-header">
                  <th class="col-index">
                    #
                  </th>
                  <th class="col-header-wider justify-content-lg-start">
                    Training Names
                  </th>
                  <th>Ranks</th>
                  <!--                                <th class="col-header-month">Vessels</th>-->
                  <th class="col-header-xwider justify-content-lg-start">
                    Provider
                  </th>
                  <th>Status</th>
                  <th>Date From</th>
                  <th>Date To</th>
                  <th>File</th>
                  <th class="col-actions-md">
                    Actions
                  </th>
                </tr>
              </thead>


              <tbody
                v-if="crewTrainings"
                class="tbody-content-middle"
              >
                <tr
                  v-for="(crewTraining,index) in crewTrainings"
                  :key="crewTraining.id"
                  :class="{ 'complete':crewTraining.trainingCompleted , 'isMandatory': crewTraining.isMandatory && !crewTraining.trainingCompleted, 'bg-expired': crewTraining.isValid === false }"
                >
                  <td scope="row">
                    {{ index + 1 }}
                  </td>
                  <td
                    v-if="crewTraining.trainingScheduleId"
                    title="View Training History"
                    @click="viewTrainingHistory(crewTraining.trainingCourseId)"
                    style="cursor: pointer"
                  >
                    <b v-if="crewTraining.allowance"><i class="fa fa-exclamation text-danger" /></b>
                    {{ crewTraining.courseName }}
                  </td>
                  <td v-else>
                    {{ crewTraining.courseName }}
                  </td>
                  <td>
                    <span v-if="crewTraining.endorsement">{{ crewTraining.endorsement.rank.alias }}</span>
                    <span v-else>{{ crewTraining.rank }}</span>
                  </td>
                  <!--                                <td>-->
                  <!--                                    <span v-if="crewTraining.endorsement">-->
                  <!--                                        {{ crewTraining.endorsement.vessel.name }}-->
                  <!--                                    </span>-->
                  <!--                                </td>-->
                  <td> {{ crewTraining.provider }}</td>
                  <td>
                    <div v-if="crewTraining.trainingScheduleId">
                      {{ evaluate(crewTraining) }}
                    </div>
                  </td>
                  <td>
                    <span v-if="crewTraining.dateFrom">{{ crewTraining.dateFrom | moment('D MMM YYYY') }}</span>
                  </td>
                  <td>
                    <span v-if="crewTraining.dateTo">{{ crewTraining.dateTo | moment('D MMM YYYY') }}</span>
                  </td>

                  <td>
                    <span v-if="crewTraining.trainingCompleted">
                      <button
                        type="button"
                        v-if="crewTraining.hasFile"
                        class="btn btn-primary btn-sm p-1 mr-1  action font-weight-bolder btn-scheduling"
                        @click="setCrewTrainingCertificateSrc(crewTraining.crewTrainingId)"
                        data-toggle="modal"
                        data-target="#viewCertificate"
                      >
                        <i class="fas fa-file" />
                        View
                      </button>
                      <template v-else>
                        <button
                          type="button"
                          v-if="crewTraining.providerId == 1"
                          class="btn btn-warning btn-sm p-1 mr-1  action font-weight-bolder btn-scheduling"
                          data-toggle="modal"
                          data-target="#uploadCertificate"
                          @click="setCrewCertificate(crewTraining)"
                        >
                          <i class="fas fa-file" />
                          Upload
                        </button>
                      </template>
                    </span>
                  </td>

                  <td>
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm p-1 mr-1  action font-weight-bolder btn-scheduling"
                      @click="$router.push('/trainingSchedule/' + crewTraining.trainingScheduleId)"
                      v-if="crewTraining.trainingScheduleId && !crewTraining.cancelledAt"
                    >
                      <i class="fas fa-eye" />
                      View
                    </button>

                    <button
                      type="button"
                      class="btn btn-warning btn-sm p-1 mr-1 action font-weight-bolder btn-scheduling"
                      data-toggle="modal"
                      data-target="#crewTrainingReschedule"
                      v-if="(crewTraining.trainingScheduleId && !(evaluate(crewTraining) === 'COMPLETED')) && isScheduler"
                      @click="setCrewTraining(crewTraining)"
                    >
                      <i class="fas fa-clock" />
                      Resched
                    </button>

                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm p-1 action font-weight-bolder btn-scheduling"
                      v-if="(crewTraining.trainingScheduleId && !(evaluate(crewTraining) === 'COMPLETED')) && !crewTraining.cancelledAt && isScheduler"
                      @click="confirmCancelCrewTrainingScheduleOnCrew(crewTraining.crewTrainingScheduleId)"
                    >
                      <i class="fas fa-ban" />
                      Cancel
                    </button>

                    <button
                      type="button"
                      class="btn btn-outline-primary btn-sm p-1 action font-weight-bolder btn-scheduling"
                      data-toggle="modal"
                      data-target="#createCrewSchedModal"
                      @click="setCrewTraining(crewTraining)"
                      v-if="(!crewTraining.trainingScheduleId || (evaluate(crewTraining) === 'COMPLETED') || crewTraining.cancelledAt) && isScheduler"
                    >
                      <i class="fas fa-clock" />
                      Sched
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="tab-pane fade show"
            id="allowance-remarks"
            role="tabpanel"
          >
            <allowance-remarks-index :crew-id="$route.params.id" />
          </div>
        </div>

        <create-crew-schedule v-if="crew.detail" />
        <reschedule-crew-training v-if="crewTraining.crewTrainingScheduleId" />
      </section>


      <div
        id="uploadCertificate"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="uploadCertificateLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header row mx-0">
              <div class="col col-sm-6">
                <h6
                  class="modal-title font-weight-bolder"
                  id="uploadCertificateLabel"
                >
                  Upload Certificate
                </h6>
              </div>

              <div class="col col-sm-6 text-right pr-0">
                <button
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-sm btn-xs btn-outline-secondary font-weight-bolder float-right"
                >
                  Cancel
                </button>

                <button
                  class="btn btn-sm btn-xs btn-outline-primary font-weight-bolder mr-1 float-right"
                  @click="confirmUploadCertificate"
                >
                  Upload
                </button>
              </div>
            </div>


            <div class="modal-body">
              <div class="form-group form-row">
                <label
                  class="col col-sm-4 col-form-label font-weight-bolder text-right pl-0"
                  for="certName"
                >Training Certificate:</label>
                <div class="col col-sm-8">
                  <input
                    type="text"
                    id="certName"
                    readonly
                    v-model="crewTrainingCertificate.trainingCourse"
                    class="form-control form-control-xs form-control-xxs"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  class="col col-sm-4 col-form-label font-weight-bolder text-right pl-0"
                  for="issuedDate"
                >Issued Date:</label>
                <div class="col col-sm-8">
                  <input
                    type="date"
                    id="issuedDate"
                    v-model="crewTrainingCertificate.issuedAt"
                    class="form-control form-control-xs form-control-xxs"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  class="col col-sm-4 col-form-label font-weight-bolder text-right pl-0"
                  for="expiryDate"
                >Expiry Date:</label>
                <div class="col col-sm-8">
                  <input
                    type="date"
                    id="expiryDate"
                    v-model="crewTrainingCertificate.expireAt"
                    class="form-control form-control-xs form-control-xxs"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  class="col col-sm-4 col-form-label font-weight-bolder text-right pl-0"
                  for="certificate"
                >Expiry Date:</label>
                <div class="col col-sm-8">
                  <input
                    type="file"
                    id="certificate"
                    class="form-control form-control-xs form-control-xxs"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-view-certificate />
    <update-anti-piracy-number :anti-piracy="antiPiracy" />
    <generate-promotion-certificate :promotion-training="promotionTraining" />
    <update-promotion-certificate :promotion-training="promotionTraining" />
    <update-crew-training-certificate :crew-training="editCrewTraining" />
<!--    <generate-crew-certificate :training-info="promotionTraining" />-->
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from '@/mixins/formMixins';
    import { gateMixins } from "@/mixins/gateMixins";
    import { trainingCourseMixin } from "@/mixins/trainingCourseMixin";
    import CreateCrewSchedule from '../crewing/CreateCrewSchedule';
    import CrewTrainingReschedule from "./CrewTrainingReschedule";
    import UpdateAntiPiracyNumber from "@/components/elements/UpdateAntiPiracyNumber";
    import ViewCertificate from "./crew_training_certificates/ViewCertificate";
    import GeneratePromotionCertificate from "@/components/elements/GeneratePromotionCertificate";
    import UpdatePromotionCertificate from "@/components/elements/UpdatePromotionCertificate";
    import UpdateCrewTrainingCertificate from "@/components/elements/UpdateCrewTrainingCertificate";
    import AllowanceRemarksIndex from "@/components/crewing/allowance-remarks/AllowanceRemarksIndex";
    // import GenerateCrewCertificate from "@/components/elements/GenerateCrewCertificate";
    //

    export default {
        mixins: [ formMixins, gateMixins, trainingCourseMixin ],
        props: ['id'],
        name: 'ViewCrew',
        components: {
            'create-crew-schedule': CreateCrewSchedule,
            'reschedule-crew-training': CrewTrainingReschedule,
            'app-view-certificate': ViewCertificate,
            UpdateAntiPiracyNumber,
            GeneratePromotionCertificate,
            UpdatePromotionCertificate,
          UpdateCrewTrainingCertificate,
          AllowanceRemarksIndex,
        },

        data() {
            return {
              isCompleted: false,
              isMandatory: false,
              crewTrainingCertificate: {
                  crewTrainingId: null,
                  trainingCourse: '',
                  issuedAt: '',
                  expireAt: '',
                  certificate: ''
              },
              promotionTraining: {},
              trainingProviderId: 1,
              editCrewTraining: {}
            }
        },
        methods: {
            ...mapActions([
                'viewCrew',
                'findCrewTrainingPerProvider',
                'getTrainingProviders',
                'setCrewTrainingsNull',
                'findCrewTrainingOthers',
                'getTrainingCourseSchedule',
                'getTrainingCentersByScheduledCourseProvider',
                'setCrewTraining',
                'updateCrewTraining',
                'cancelCrewTrainingScheduleOnCrew',
                'getTheCountofTrainings',
                'updateCrewCertificate',
                'setCrewTrainingCertificateSrc',
                'findCrewChecklist',
                'generateAllTrainingChecklist',
                'generateOnGoingTrainingChecklist',
                'findAllAcquiredTraining'
            ]),

            crewTrainingsPerProvider(id) {
                let crewId = this.id;
                let providerId = id;
                this.trainingProviderId = id;
                this.findCrewTrainingPerProvider({crewId, providerId});
            },

            getCrewTrainingChecklist() {
              this.trainingProviderId = null;
                this.findCrewChecklist(this.id);
            },

            getAllAcquiredTraining() {
              this.trainingProviderId = null;
                this.findAllAcquiredTraining(this.id);
            },

            crewTrainingsOthers() {
                let crewId = this.id;
                this.findCrewTrainingOthers({crewId});
            },

            printInProcess() {
                alert('initialize print in process');
            },
            setFormParams(crewTraining) {
                this.formParams.selectedCourseId = crewTraining.courseId;
                this.formParams.trainingProviderId = crewTraining.trainingProviderId;
                this.formParams.trainingCourseProviderId = crewTraining.trainingCourseProviderId;
                this.getTrainingCentersByScheduledCourseProvider();
            },
            async setCrewTraining(crewTraining) {
                this.updateCrewTraining(crewTraining);
                await this.getTrainingCentersByScheduledCourseProvider(this.trainingProviderId);

                if (this.formParams.trainingCenters[0]) {
                    // this.formParams.trainingCenterSchedules = this.formParams.trainingCenters[0].trainingSchedules
                    this.formParams.trainingCenterSchedules = this.formParams.trainingCenters[0].training_schedules
                        .filter(schedule => {
                            return schedule.date_from !== this.crewTraining.dateFrom && schedule.date_to !== this.crewTraining.dateTo
                        });
                } else {
                    this.formParams.trainingCenterSchedules = [];
                }
            },
            evaluate(crewTraining) {
                if (crewTraining.cancelledAt) {
                    return 'CANCELLED';
                }

                if (crewTraining.wasConducted && !crewTraining.trainingCompleted) {
                    return 'INCOMPLETE'
                } else if (!crewTraining.wasConducted) {
                    let dateFrom = new Date(crewTraining.dateFrom);
                    let dateTo = new Date(crewTraining.dateTo);
                    let dateNow = new Date();
                    if (dateFrom > dateNow) {
                        return 'PENDING';
                    } else if (dateFrom >= dateNow && dateNow <= dateTo) {
                        return 'ON GOING';
                    } else {
                        console.log(crewTraining.wasConducted, crewTraining);
                        return 'tsk';
                    }
                } else if (!crewTraining.isValid) {
                    return 'EXPIRED';
                } else if (crewTraining.trainingCompleted && crewTraining.wasConducted) {
                    return 'COMPLETED';
                } else {
                    return 'INCOMPLETE';
                }
            },
            async confirmCancelCrewTrainingScheduleOnCrew(crewTrainingScheduleId) {
                if (await this.deleteAlert('Are you sure you want to cancel this schedule?', 'CONFIRM CANCEL SCHEDULE')) {
                    if (await this.cancelCrewTrainingScheduleOnCrew(crewTrainingScheduleId)) {
                        this.successAlert('Crew Training Schedule Successfully Cancelled', 'TRAINING SCHEDULE CANCEL');
                    } else {
                        this.errorAlert(this.generateErrorMessage(null, 'CANCEL SCHEDULE'));
                    }
                }
            },

            setCrewCertificate(crewTraining) {
                this.crewTrainingCertificate.crewTrainingId = crewTraining.crewTrainingId;
                this.crewTrainingCertificate.trainingCourse = crewTraining.courseName;
                this.crewTrainingCertificate.issuedAt = crewTraining.dateTo;
            },

            confirmUploadCertificate() {
                let file = document.getElementById('certificate').files[0];
                let formData = new FormData();
                formData.append('crewTrainingId', this.crewTrainingCertificate.crewTrainingId);
                formData.append('issuedAt', this.crewTrainingCertificate.issuedAt);
                formData.append('expiryDate', this.crewTrainingCertificate.expireAt);
                formData.append('certificate', file);

                this.updateCrewCertificate(formData);
            },

            viewTrainingHistory(trainingCourseId) {
                this.$router.push({
                    name: 'crewTrainingHistory',
                    params: {
                        crewId: this.id,
                        courseId: trainingCourseId
                    }
                });
            }

        },

        computed: {
            ...mapGetters(['crew', 'crewTrainingProviders', 'crewTrainings', 'formParams', 'crewTraining', 'countTrainingRescheduled', 'countTrainingScheduled', 'countTrainingCompleted']),
          antiPiracy() {
              let crewTraining = this.crewTrainings.find(crewTraining => crewTraining.trainingCourseId === 2);
              return crewTraining ? Object.assign({}, crewTraining) : {};
          }
        },

        created() {
            // let providerId = "1";
            let crewId = this.id;
            this.formParams.crewId = crewId;
            this.formParams.trainingProviderId===null;
            this.viewCrew(this.id);
            this.getCrewTrainingChecklist();
            // this.findCrewTrainingPerProvider({providerId, crewId});
        },

        mounted() {
            $(document).ready(function () {
                $('[data-toggle="popover"]').popover();
            });
        }
    };
</script>

<style scoped>

    .table tr {
        text-align: left;
    }

    .action {
        font-size: 0.7em;
    }

    label {
        font-weight: bold;
    }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        color: #495057;
        background-color: #2c9faf;
        border-color: #fbfdff #dee2e6 #fff;
    }

</style>
